import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from 'kea-resource';
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

import { EntregaZERealizada } from "./entregazerealizada";
import { SaldosUsuariosZE } from "./saldousuariosze";

const controller = rpcController("LiberacionEntregaZE");
const crud = rpcCrudService<models.LiberacionEntregaZE, models.LiberacionEntregaZEDTO>(controller);

const otros = {
    LiberarEntregas: async (idEntregasZE: number[]): Promise<models.EntregaZERealizadaDTO[]> => await controller("LiberarEntregas", {}, idEntregasZE),

    /**Imprime los contrarecibos de una liberación de entregas de zona extendida */
    ImprimirAcusesInternos: async (idLiberacionEntregaZE: number): Promise<string> => await controller('ImprimirAcusesInternos', { idLiberacionEntregaZE }),

    /**Obtiene una liberacion con sus listas */
    GetLiberacion: async (idLiberacionEntregaZE: number): Promise<models.LiberacionEntregaZEDTO> => await controller('GetLiberacion', { idLiberacionEntregaZE }),
}

export const LiberacionEntregaZE = cacheResource({
    ...crud,
    ...otros
}, {
    }, {
        LiberarEntregas: true
    });

addOnInvalidateHandler(LiberacionEntregaZE, () => invalidateResource(EntregaZERealizada));
addOnInvalidateHandler(LiberacionEntregaZE, () => invalidateResource(SaldosUsuariosZE));


// WEBPACK FOOTER //
// ./app/resources/items/liberacionentregaze.ts